module.exports = __webpack_public_path__ + "img/box7-9-9.ac37120f.png";